<template>

  <div class="col-12 table-responsive">

    <table class="table table-bordered">

      <tr>
        
        <th 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key" >
          {{ tableParameterItem.text || tableParameterItem.key }}
        </th>

        <th v-show="leaseEnableAddDelete">
          Delete
        </th>

      </tr>

      <tr 
        v-for="(leaseDataItem, leaseDataIndex) in leaseData"
        v-bind:key="leaseDataItem.id" >

        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key" 
          v-show="getCellVisibility(tableParameterItem, leaseDataItem, leaseDataIndex, leaseData)"
          v-bind:rowspan="getCellSpan(tableParameterItem, leaseDataItem, leaseDataIndex, leaseData)">

          <div v-if="tableParameterItem.key === 'seasonID'">
            <select
              class="form-control"
              v-show="leaseEnableEdit"
              v-model="leaseDataItem[tableParameterItem.key]"
              v-bind="leaseEnableEdit && leaseDataItem.tandemIndex === undefined ? {} : {disabled: 1}"
              v-on:change="onProductChange(leaseDataIndex)" >
              <option 
                v-for="season in tableSeason"
                v-bind:key="season.id"
                v-bind:value="season.id"
                v-bind="season._disabled ? {disabled:1} : {}">
                {{ getSeasonOption(season) }}
              </option>
            </select>

            <div 
              v-show="!leaseEnableEdit" >
              {{ leaseDataItem['leaseProductName'] }}
            </div>
          </div>

          <div v-else-if="tableParameterItem.key === 'parkerID'">
            <select
              class="form-control"
              v-show="leaseEnableEdit"
              v-model="leaseDataItem[tableParameterItem.key]"
              v-bind="leaseEnableEdit ? {} : {disabled: 1}"
              v-on:change="onParkerChange(leaseDataIndex)" >
              <option 
                v-for="parker in tableParker"
                v-bind:key="parker.id"
                v-bind:value="parker.id"
                v-bind:style="parker.id === 'add' ? 'color: rgb(30, 136, 229);' : ''">
                {{ parker.name }}
              </option>
            </select>

            <div
              v-show="!leaseEnableEdit" >
              {{ leaseDataItem['leaseParkerName'] }}
            </div>
          </div>

          <div v-else-if="tableParameterItem.key === 'isParkAide'" >
            <input
              type="checkbox"
              v-bind="leaseEnableEdit ? leaseParkaideEnable : {disabled:1}"
              v-bind:true-value="1"
              v-bind:false-value="0"
              v-model="leaseDataItem[tableParameterItem.key]"/>
          </div>

          <div v-else >
            {{ leaseDataItem[tableParameterItem.key] }}
          </div>
          
        </td>

        <td v-show="leaseEnableAddDelete">
          <div
            v-show="leaseDataItem.tandemIndex === undefined">
            <a
              v-on:click.prevent="onLeaseDeleteClick(leaseDataIndex)"
              href="#" >
              Delete
            </a>
          </div>
        </td>

      </tr>

      <tr>
        <td 
          v-for="tableParameterItem in PARAM" 
          v-bind:key="tableParameterItem.key" >
          {{ leaseTotal[tableParameterItem.key] }}
        </td>

        <td v-show="leaseEnableAddDelete"/>

      </tr>
        
    </table>

    <button 
      v-show="leaseEnableAddDelete"
      class="btn btn-rounded btn-primary"
      v-on:click.prevent="onLeaseAddClick">
      Add Product Subscription
    </button>

    <TemplateFeedback ref="leaseFeedback" class="mt-1"/>

  </div>

</template>

<script>
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import helper from "@/components/Utility/Helper"

const PARAM = [
  {
    key: 'seasonID',
    text: 'Car Park Product'
  },
  {
    key: 'leaseProductDepositText',
    text: 'Deposit (RM)',
  },
  {
    key: 'leaseProductEstbFeeText',
    text: 'Estb. Fee (RM)',
  },
  {
    key: 'leaseProductInitialParkingFeeText',
    text: 'Initial Parking Fee (RM)',
  },
  {
    key: 'leaseProductInitialPaymentText',
    text: 'Initial Payment (RM)',
  },
  {
    key: 'leaseProductParkingFeeText',
    text: 'Parking Fee (RM)',
  },
  {
    key: 'parkerID',
    text: 'Parker',
  },
  {
    key: 'leaseParkerMobile',
    text: 'Mobile No.',
  },
  {
    key: 'leaseParkerPlate',
    text: 'Plate',
  },
  {
    key: 'leaseParkerEmail',
    text: 'Email',
  },
  {
    key: 'isParkAide',
    text: 'Enable ParkAide',
  },
];

export default {
  name: "PagePLAddOnFormLease",
  props: ['tableParameter'],
  components: {
    TemplateFeedback,
  },
  data () {
    return {
      PARAM,

      tableSeason: null,
      tableParker: null,

      leaseData: [{}],
      leaseTotal: {},
      leaseEnableAddDelete: false,
      leaseEnableEdit: false,
      leaseParkaideEnable: {},

      PRODUCT_PARAMS: ['leaseProductDeposit', 'leaseProductEstbFee', 'leaseProductInitialParkingFee', 'leaseProductInitialPayment', 'leaseProductParkingFee'],
      PARKER_PARAMS: ['leaseParkerName', 'leaseParkerMobile', 'leaseParkerPlate', 'leaseParkerEmail'],
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }
  },
  methods: {
    setFeedbackLoading(message) {
      this.$refs['leaseFeedback'].setFeedbackLoading(message);
    },
    setFeedbackError(error) {
      this.$refs['leaseFeedback'].setFeedbackError(error);
    },
    setFeedbackMessage(message) {
      this.$refs['leaseFeedback'].setFeedbackMessage(message);
    },

    getSeasonOption(season) {
      let option = season.name;
      if(season._zoneName) {
        option += ' - ' + season._zoneName
      }
      option += ' (' + (season._disabled || season._actualBayAvailable) + ')'
      return option;
    },
    getCellVisibility(tableParameterItem, leaseDataItem, leaseDataIndex, leaseData) {
      if(leaseDataIndex === 0) {
        return true;
      }

      let pairIDKey = 'pairID';
      pairIDKey = 'data5';
      if(leaseDataItem[pairIDKey]) {
        if(leaseDataItem[pairIDKey] === leaseData[leaseDataIndex - 1][pairIDKey]) {
          if(this.shouldRowSpan(tableParameterItem)) {
            return false;
          }
        }
      }

      return true;
    },
    getCellSpan(tableParameterItem, leaseDataItem, leaseDataIndex, leaseData) {
      let pairIDKey = 'pairID';
      pairIDKey = 'data5';
      if(!leaseDataItem[pairIDKey]) {
        return 1;
      }

      let span = 1;
      for(let start = leaseDataIndex + 1; start<leaseData.length; start++) {
        if(leaseData[start] && leaseData[start][pairIDKey] && leaseDataItem[pairIDKey] === leaseData[start][pairIDKey]) {
          if(this.shouldRowSpan(tableParameterItem)) {
            span++;
            continue;
          }
        }

        break;
      }

      return span;
    },
    shouldRowSpan(tableParameterItem) {
      if(this.PRODUCT_PARAMS.includes(tableParameterItem.key) || this.PRODUCT_PARAMS.includes(tableParameterItem.key.substring(0, tableParameterItem.key.length - 4))) {
        return true;
      }
      if(tableParameterItem.key === 'seasonID') {
        return true;
      }
    },

    setSeasonData(tableSeason) {
      this.tableSeason = tableSeason || [];
      this.leaseData.forEach(k => {
        let season = this.tableSeason.find(j => (j.id === k['seasonID']) && !j['_disabled']);
        this.setLeaseDataSeason(k, season);
      });
    },
    setParkerData(tableParker) {
      this.tableParker = tableParker || [];
      this.tableParker.unshift({id: 'add', name: 'Add Parker'});
      this.leaseData.forEach(k => {
        let parker = this.tableParker.find(j => j.id === k['parkerID']);
        this.setLeaseDataParker(k, parker);
      });
    },
    setLeaseData(leaseData) {
      this.leaseData = leaseData || [];
    },
    setLeaseParkaideEnable(leaseParkaideEnable) {
      //parkaide force = disabled, checked
      //parkaide optional = enabled, checked/unchecked
      //parkaide force/optional = disabled, unchecked
      this.leaseParkaideEnable = leaseParkaideEnable ? {} : {disabled: 1};
    },
    setLeaseTotal(leaseTotal) {
      leaseTotal = leaseTotal || {};
      this.PRODUCT_PARAMS.forEach(k => {
        leaseTotal[k + 'Text'] = leaseTotal[k + 'Text'] || helper.formatMoney(leaseTotal[k]);
      });
      leaseTotal['seasonID'] = 'Total (RM)';
      this.leaseTotal = leaseTotal;
    },
    setLeaseEnableAction(enableAddDelete, enableEdit) {
      this.leaseEnableAddDelete = enableAddDelete;
      this.leaseEnableEdit = enableEdit;
    },

    onProductChange(leaseDataIndex) {
      this.$refs['leaseFeedback'].setFeedbackMessage();
      this.$emit('lease-season-select', leaseDataIndex, this.leaseData[leaseDataIndex]['seasonID'], this.leaseData[leaseDataIndex]['oldSeasonID']);
      this.leaseData[leaseDataIndex]['oldSeasonID'] = this.leaseData[leaseDataIndex]['seasonID'];
    },
    onParkerChange(leaseDataIndex) {
      this.$refs['leaseFeedback'].setFeedbackMessage();
      let parker = this.tableParker.find(k => k.id === this.leaseData[leaseDataIndex]['parkerID']);
      this.setLeaseDataParker(this.leaseData[leaseDataIndex], parker);
      if(this.leaseData[leaseDataIndex]['parkerID'] === 'add') {
        this.$emit('lease-parker-add', leaseDataIndex);
      }
    },
    onLeaseAddClick() {
      this.$refs['leaseFeedback'].setFeedbackMessage();
      if(this.leaseData.length < 50) {
        this.leaseData.push({});
      }
    },
    onLeaseDeleteClick(leaseDataIndex) {
      if(this.leaseData.length <= 1) {
        this.$refs['leaseFeedback'].setFeedbackError('Please keep at least one subscription in application.');
      } else {
        let oldSeasonId = this.leaseData[leaseDataIndex]['seasonID'];
        this.leaseData.splice(leaseDataIndex, 1);
        this.$emit('lease-season-remove', leaseDataIndex, oldSeasonId);
      }
    },

    setLeaseDataSeason(data, season) {
      if(!season) {
        data['seasonID'] = null;
        this.removeLeaseDataSeasonField(data);
      }
    },
    setLeaseDataParker(data, parker) {
      if(!parker) {
        data['parkerID'] = null;
        this.removeLeaseDataParkerField(data);
      } else {
        data['leaseParkerName'] = parker['name'];
        data['leaseParkerMobile'] = parker['mobile'] || parker['username'];
        data['leaseParkerPlate'] = parker['car1'];
        data['leaseParkerEmail'] = parker['email'];
        this.$forceUpdate();
      }
    },
    
    removeLeaseDataSeasonField(data) {
      this.PRODUCT_PARAMS.forEach(k => {
        data[k] = null;
        data[k + 'Text'] = null;
      })
    },
    removeLeaseDataParkerField(data) {
      this.PARKER_PARAMS.forEach(k => {
        data[k] = null;
      })
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/ParkingLicense/PagePLAddOnFormLease.vue